import angular from 'angular';
import UIRouter from 'angular-ui-router';

import createStub from '../olr-common/createStub';
import './styles/index.scss';
import template from './index.html';
import AnnouncementController from './AnnouncementController';
    
    let namespace = angular.module('olr-mainfe-announcement', [
      UIRouter,
      'olr-common'
    ]);

    namespace.config(function($stateProvider) {
      $stateProvider.state('olr.mainfe.announcement', {
        url: '/announcement',
        controller: AnnouncementController,
        template: template
      });
    });

    namespace.factory("announcementConfig", () => { return this.config; });
    namespace.controller('AnnouncementController', AnnouncementController);

    export default namespace.name;




/** WEBPACK FOOTER **
 ** ./src/olr-mainfe-announcement/index.js
 **/